import { useSelector } from 'react-redux';
import UIButton from 'UIComponents/button/UIButton';
import UILockBadge from 'UIComponents/badge/UILockBadge';
import { useUpgradeModalInIframe } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { getHasAudioNarrationAccess
// @ts-expect-error Not migrated yet
} from '../../redux/selectors/authSelectors';
import { UPGRADE_POINT_KEY } from '../../constants/audioNarration';
import { jsx as _jsx } from "react/jsx-runtime";
const NarrationFeatureBadge = () => {
  const hasAudioNarrationAccess = useSelector(getHasAudioNarrationAccess);
  const {
    openUpgradeModal
  } = useUpgradeModalInIframe(UPGRADE_POINT_KEY);
  if (hasAudioNarrationAccess) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIButton, {
    onClick: openUpgradeModal,
    use: "transparent",
    children: /*#__PURE__*/_jsx(UILockBadge, {})
  });
};
export default NarrationFeatureBadge;